import moment, { Moment } from 'moment';
import { Submission } from '../App/Content/UserDeveloper/Submission/submission-graphql';
import { SubmissionStatusChange } from '../App/Content/Admin/Game/gql/submission-graphql';

type SubmissionBasicLaunchEnd = Pick<Submission, 'basicLaunchExpiresOn' | 'statusChanges' | 'status'>;

export function submissionHadBasicLaunch(statusChanges: SubmissionStatusChange[]): boolean {
  const basicLaunchStatuses = ['BASIC_LAUNCH', 'BASIC_LAUNCH_APPROVED', 'BASIC_LAUNCH_AWAITING_DEVELOPER_CHANGE'];

  return statusChanges.some((change) => basicLaunchStatuses.includes(change.status));
}

export function submissionHasBasicLaunchExpired(submission: SubmissionBasicLaunchEnd): { endsOn: string | null; hasExpired: boolean } {
  const standardBasicLaunchEndsOn = submission.basicLaunchExpiresOn ? moment.utc(submission.basicLaunchExpiresOn) : null;

  const fullLaunchChanges = submission.statusChanges.filter((change) => change.status === 'BASIC_LAUNCH' && change.isFullLaunch === true);

  let calculatedBasicLaunchEndsOn: Moment | null = null;

  // if no full launch status change exists, use the basicLaunchEndOn value
  if (fullLaunchChanges.length === 0) {
    calculatedBasicLaunchEndsOn = standardBasicLaunchEndsOn;
  }

  // if there was a full launch status change, find the earliest one (there should only be one)
  const earliestFullLaunchChange = fullLaunchChanges.reduce((earliest, current) => {
    return moment.utc(current.changedOn).isBefore(moment.utc(earliest.changedOn)) ? current : earliest;
  }, fullLaunchChanges[0]);
  // and use it if it's before the default basic launch end
  if (earliestFullLaunchChange && moment.utc(earliestFullLaunchChange.changedOn).isBefore(standardBasicLaunchEndsOn)) {
    calculatedBasicLaunchEndsOn = moment.utc(earliestFullLaunchChange.changedOn);
  }

  // check if calculatedBasicLaunchEndsOn has passed
  const hasExpired =
    (calculatedBasicLaunchEndsOn && submission.status === 'BASIC_LAUNCH' && calculatedBasicLaunchEndsOn.isBefore(moment.utc())) ?? false;

  return {
    endsOn: calculatedBasicLaunchEndsOn ? calculatedBasicLaunchEndsOn.format('YYYY-MM-DD HH:mm:ss') : null,
    hasExpired: hasExpired,
  };
}
